import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthService from "../services/AuthService";
import ApiService from "../services/ApiService";
import { CiSearch } from "react-icons/ci";
import { LiaUserCircleSolid, LiaShoppingBagSolid } from "react-icons/lia";
import { MdHomeFilled,  MdOutlineArrowDropDown } from "react-icons/md";

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    age: ""
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (!/^\d{9,10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number is invalid";
    }
    if (!formData.age) {
      newErrors.age = "Age is required";
    } else if (isNaN(formData.age) || formData.age < 13 || formData.age > 80) {
      newErrors.age = "Age must be between 13-120";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const appData = { ...formData };
      appData.phone = "971" + appData.phone;
      const response = await ApiService.request({
        method: "POST",
        url: "/register",
        data: appData
      });

      if (response.data.status) {
        const { user } = response.data.data;
        localStorage.setItem('user_id',user._id);
        navigate("/verify-otp");
      } else {
        toast.error(response.data.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error("An error occurred during registration");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="header-banner bg-gradient" id="home">
      <div className="container">
        <div className="row">
          <div
            className="col-md-12 shadow main-heading"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {/* Reused Header */}
            <div className="top-bar d-flex justify-content-between px-4 py-2">
              <div className="top-bar-left">
                <span className="text-secondary">Welcome</span>
                <p className="mb-0 text-base">Create your account</p>
              </div>

              <div className="top-bar-right d-flex align-items-center">
                {/* <Link to="/login">
                  <LiaUserCircleSolid className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary" />
                </Link>
                <Link to="/cart">
                  <LiaShoppingBagSolid className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary" />
                </Link> */}
                <Link  to="/">
                        <MdHomeFilled  className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary"  />
                </Link>
                <Link to="/search">
                    <CiSearch className="top-bar-search-icon fs-2 text-secondary" />
                </Link>
              </div>
            </div>

              {/* Registration Form */}
              <div className="row">
                <div className="tab col-md-6 col-12 my-5 mx-auto  bg-white rounded border shadow p-4">
                  <h2 className="text-center mb-4">Register</h2>
                  
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      
                      <div className="mb-3 col-md-12">
                        <label htmlFor="name" className="form-label required">
                          Full Name
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                          placeholder="Enter Full Name"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="invalid-feedback">{errors.name}</div>
                        )}
                      </div>

                      <div className="mb-3 col-md-12">
                        <label htmlFor="email" className="form-label required">
                          Email Address
                        </label>
                        <input
                          type="email"
                          placeholder="Your Email Address"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>

                      <div className="mb-3 col-md-12">
                        <label htmlFor="password" className="form-label required">
                          Password
                        </label>
                        <input
                          type="password"
                          placeholder=" Password"
                          className={`form-control ${errors.password ? "is-invalid" : ""}`}
                          id="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">{errors.password}</div>
                        )}
                      </div>

                      <div className="mb-3 col-md-6">
                        <label htmlFor="phone" className="form-label required">
                          Phone Number
                        </label>
                        <div className="input-group">
                          <span className="group-prepand bg-light p-2 border ">
                            +971
                          </span>
                          <input
                            type="tel"
                            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                            id="phone"
                            placeholder=" Phone Number"
                            name="phone"
                            maxLength={9}
                            value={formData.phone}
                            onChange={handleChange}
                          />
                        </div>
                        
                        {errors.phone && (
                          <div className="invalid-feedback">{errors.phone}</div>
                        )}
                      </div>

                      <div className="mb-3 col-md-6">
                        <label htmlFor="age" className="form-label required">
                          Age
                        </label>
                        <input
                          type="number"
                          className={`form-control ${errors.age ? "is-invalid" : ""}`}
                          id="age"
                          name="age"
                          min="13"
                          max="80"
                          value={formData.age}
                          onChange={handleChange}
                        />
                        {errors.age && (
                          <div className="invalid-feedback">{errors.age}</div>
                        )}
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-base w-100 py-2 mb-3"
                      disabled={isLoading}
                    >
                      {isLoading ? "Registering..." : "Create Account"}
                    </button>

                    <div className="text-center">
                      <p>
                        Already have an account?{" "}
                        <Link to="/login" className="text-base">
                          Login here
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>

              </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;